var exports = {
  "a": "TitleWrapper__4f5JPQ",
  "i": "NarrowOnly__KfauzV",
};

module.exports = exports;
